export default {
  form: {
    country: {
      label: 'País',
      placeholder: 'Seleccionar país',
    },
  },
};
